(function() {

    'use strict';



    var XML2 = SAPO.Utility.XML2;



    var toBool = function(s) { return (s.toLowerCase() === 'true'); };
    var toInt  = function(s) { return parseInt(s, 10); };



    function MediaFileParser(el) {

        // required
        var item = {
            nodeName: el.nodeName,
            src:      XML2.trim( XML2.text(el) ), // element content
            type:     el.getAttribute('type').toLowerCase(),
            dims: [ // width and height
                toInt( el.getAttribute('width')  ),
                toInt( el.getAttribute('height') )
            ],
            delivery: el.getAttribute('delivery') // progressive/streaming
        };



        // from elsewhere (Linear < MediaFiles < el)
        var duration = XML2.getText(el.parentNode.parentNode, 'Duration');
        if (duration) {
            item.duration = XML2.parseTime( duration );
        }



        // optional

        if (el.getAttribute('bitrate')) {
            item.bitrate = toInt( el.getAttribute('bitrate') );
        }

        if (el.getAttribute('minBitrate')) {
            item.bitrate = toInt( el.getAttribute('minBitrate') );
        }

        if (el.getAttribute('maxBitrate')) {
            item.bitrate = toInt( el.getAttribute('maxBitrate') );
        }

        if (el.getAttribute('maintainAspectRatio')) {
            item.maintainAspectRatio = toBool( el.getAttribute('maintainAspectRatio') );
        }

        if (el.getAttribute('scalable')) {
            item.maintainAspectRatio = toBool( el.getAttribute('scalable') );
        }

        if (el.getAttribute('apiFramework')) {
            item.maintainAspectRatio = toBool( el.getAttribute('apiFramework') );
        }

        return item;
    }



    SAPO.Project.Video.VAST.parsers.MediaFile = MediaFileParser;

})();
